import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from "./router/index";
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
import './common/global.css';

Vue.use(ElementUI)
Vue.config.productionTip = false

import {get,post,postFile} from './common/request'
Vue.prototype.$httpGet = get
Vue.prototype.$httpPost = post
Vue.prototype.$postFile = postFile

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
